import cx from "classnames";
import React from "react";
import { FieldErrorsImpl } from "react-hook-form";

import { InputError } from "@/components/elements/InputError";
import { InputLabel } from "@/components/elements/InputLabel";
import { Text } from "@/components/elements/Text";

import styles from "./styles.module.css";

export type InputTextType = {
  name: string;
  label: string;
  type?: string;
  placeholder?: string;
  helperText?: string;
  readOnly?: boolean;
  hidden?: boolean;
};

export type InputTextThemes = "dark" | "light";
export type InputTextVersion = "underline" | "box";

export interface InputTextProps extends InputTextType {
  id: string;
  hideLabel?: boolean;
  errors?: FieldErrorsImpl;
  disabled?: boolean;
  readOnly?: boolean;
  internationalCode?: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  register?: any;
  theme?: InputTextThemes;
  version?: InputTextVersion;
  className?: string;
  inputClassName?: string | undefined;
}

export const InputText = ({
  label,
  hideLabel = false,
  errors,
  id,
  name,
  type = "text",
  placeholder,
  helperText,
  internationalCode = "+47",
  disabled = false,
  readOnly = false,
  hidden = false,
  register,
  theme = "light",
  version = "underline",
  className,
  inputClassName,
}: InputTextProps) => {
  return (
    <div
      className={cx(
        styles.container,
        styles[theme],
        styles[version],
        { [styles.hidden]: hidden },
        className
      )}
    >
      <InputLabel id={id} hidden={hideLabel}>
        {label}
      </InputLabel>
      <div className={styles.inputWrapper}>
        {type === "tel" && (
          <Text as="span" className={styles.telPrefix}>
            {internationalCode}
          </Text>
        )}
        <input
          id={id}
          name={name}
          type={type === "textarea" ? undefined : type}
          className={cx(styles.input, inputClassName)}
          placeholder={placeholder}
          disabled={disabled}
          {...register(name)}
          readOnly={readOnly}
        />
      </div>
      {helperText && (
        <Text size="xxs" className={styles.helperText}>
          {helperText}
        </Text>
      )}
      <InputError errors={errors} inputName={name} />
    </div>
  );
};
